import React from 'react'

const PaymentQrLayer = () => {
  return (
    <div>
      PaymentQrLayer
    </div>
  )
}

export default PaymentQrLayer
